"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgPerson05Positive = function SvgPerson05Positive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M22.15 50.824a2.118 2.118 0 01-2.117-2.118c0-.367-.085-9.007 3.748-14.619a2.13 2.13 0 113.53 2.386c-3.1 4.56-3.043 12.162-3.043 12.233 0 1.17-.948 2.118-2.117 2.118zM88.941 50.859a2.118 2.118 0 01-2.117-2.153 29.944 29.944 0 00-1.56-9.29 13.602 13.602 0 00-1.455-2.887 2.13 2.13 0 113.53-2.385 17.541 17.541 0 011.927 3.797 33.734 33.734 0 011.793 10.828 2.118 2.118 0 01-2.118 2.09z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M108.89 107.619a2.118 2.118 0 01-2.118-2.118V55.504c0-28.315-22.954-51.269-51.268-51.269-28.315 0-51.269 22.954-51.269 51.269v30.529a2.118 2.118 0 01-4.235 0v-30.53C0 24.85 24.85 0 55.504 0c30.653 0 55.503 24.85 55.503 55.504V105.5c0 1.17-.948 2.118-2.118 2.118z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M105.699 110.824H88.856a2.118 2.118 0 110-4.236H105.7a1.073 1.073 0 001.073-1.073 2.118 2.118 0 014.235 0 5.308 5.308 0 01-5.308 5.309z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M12.918 76.327A2.118 2.118 0 0110.8 74.21c0-9.268 3.332-14.823 8.915-14.823h.94c1.721 0 4.234.755 6.6 4.341a2.118 2.118 0 01-3.53 2.308c-.586-.903-1.765-2.414-3.05-2.414h-.96c-3.451 0-4.68 5.464-4.68 10.588 0 1.17-.948 2.118-2.117 2.118z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M8.866 142.899a2.118 2.118 0 01-1.334-3.755c3.607-2.937 17.739-10.045 25.877-12.452v-16.75a2.118 2.118 0 014.236 0v18.352a2.118 2.118 0 01-1.645 2.09c-6.946 1.616-22.376 9.26-25.8 12.042a2.118 2.118 0 01-1.334.473z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M102.198 142.899c-.486 0-.957-.167-1.334-.473-3.424-2.781-18.848-10.412-25.808-12.042a2.118 2.118 0 01-1.63-2.062v-18.826a2.118 2.118 0 114.235 0v17.196c8.132 2.407 22.27 9.515 25.878 12.452a2.118 2.118 0 01-1.341 3.755z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M55.482 119.923c-14.343 0-27.36-12.064-32.767-30.205h-1.588c-5.788 0-10.327-6.82-10.327-15.53a2.118 2.118 0 014.235 0c0 5.337 2.5 11.294 6.092 11.294h3.155a2.118 2.118 0 012.076 1.567c4.602 17.14 16.306 28.652 29.124 28.652 1.04.002 2.078-.072 3.106-.219a2.118 2.118 0 11.593 4.193c-1.225.17-2.461.253-3.699.248z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M72.233 113.598a2.118 2.118 0 01-1.341-3.756 32.725 32.725 0 003.127-2.922c4.807-5.09 8.47-12 10.588-19.885a2.118 2.118 0 012.075-1.567h3.163c3.586 0 6.091-5.943 6.091-11.294 0-5.11-1.235-10.588-4.68-10.588h-.945c-.946 0-2.316 1.052-2.944 2.245a2.118 2.118 0 11-3.748-1.97c1.172-2.237 3.847-4.51 6.692-4.51h.945c5.577 0 8.916 5.54 8.916 14.823 0 8.697-4.54 15.53-10.327 15.53h-1.61c-2.357 7.927-6.19 14.823-11.146 20.11a38.605 38.605 0 01-3.529 3.297c-.374.31-.842.481-1.327.487z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M89.845 89.725h-3.22a2.118 2.118 0 110-4.236h3.163c1.814 0 3.67-1.764 4.85-4.602a2.118 2.118 0 013.91 1.624c-1.842 4.517-5.09 7.214-8.703 7.214z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M25.475 67.01a2.118 2.118 0 01-1.334-3.756c.706-.586 2.548-2.534 2.548-4.503a2.118 2.118 0 114.236 0c0 4.334-3.692 7.447-4.116 7.764a2.118 2.118 0 01-1.334.494zM85.51 67.01a2.118 2.118 0 01-1.489-.608c-.374-.374-3.65-3.734-3.65-7.764a2.118 2.118 0 114.236 0c0 1.92 1.73 4.073 2.4 4.743a2.118 2.118 0 010 2.993 2.118 2.118 0 01-1.496.635z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M88.941 50.859h-66.79a2.118 2.118 0 010-4.235h66.79a2.118 2.118 0 010 4.235zM22.214 110.824H5.273A5.308 5.308 0 010 105.5V72.05a2.118 2.118 0 014.235 0v33.452a1.073 1.073 0 001.066 1.087h16.941a2.118 2.118 0 010 4.236h-.028z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M95.562 97.475a2.118 2.118 0 111.495-.617c-.398.397-.939.62-1.502.617h.007zM15.53 97.475a2.118 2.118 0 111.48-.602c-.408.398-.96.616-1.53.602h.05z",
    fill: "#1B7"
  })));
};

var _default = SvgPerson05Positive;
exports["default"] = _default;